import AxiosFactory from '@/entities/security/AxiosFactory'
import ApiErrorFactory from '@/entities/errors/api_errors/ApiErrorsFactory'
import { RESET_USER_PASSWORD_URL, UPDATE_USER_PASSWORD_WITH_TOKEN_URL } from '@/modules/forgotPassword/endpoints'
import { ForgotUserPasswordPayloadI } from '@/modules/forgotPassword/types/api/ForgotUserPassword'
import BaseError from '@/entities/errors/api_errors/BaseError'

export default class ForgotPasswordApi {
  async resetUserPassword(data: ForgotUserPasswordPayloadI) {
    try {
      const axios = await AxiosFactory.createAxiosInstanceWithCsrf()
      const response = await axios.post(RESET_USER_PASSWORD_URL, data)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async checkIsTokenValid(token: string): Promise<boolean> {
    try {
      const axios = await AxiosFactory.createAxiosInstanceWithCsrf()
      await axios.get(`${RESET_USER_PASSWORD_URL}/${token}`)
      // Validity is carried by the status code, not the body: the endpoint answers 2xx for a
      // usable token and 422 with a `token` field error for one that is expired or unknown.
      return true
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async updatePasswordWithToken(payload: object) {
    try {
      const axios = await AxiosFactory.createAxiosInstanceWithCsrf()
      const response = await axios.post(UPDATE_USER_PASSWORD_WITH_TOKEN_URL, payload)
      if (response.data && response.data.result && response.data.result === 'error' && response.data.message) {
        throw new BaseError(response.data.message)
      }
      return response.data
    } catch (e) {
      if (e instanceof BaseError) throw e
      throw ApiErrorFactory.create(e)
    }
  }
}
